import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { selectIsSubscriptionRestricted } from "../app/auth/authSlice";
import {
  getDefaultAuthorizedPath,
  hasReportRouteAccess,
  hasSectionAccess,
  resolveSectionByPath,
} from "../utils/permissions";
import { isPathBlockedForCompany } from "../utils/companyCapabilities";
import { LOGIN_PATH } from "../utils/authRedirect";
import { BILLING_PATH, isBillingAllowedPath } from "../utils/subscriptionAccess";

const PrivateRoute = () => {
  const user = useSelector((state) => state.auth.user);
  const authProfileData = useSelector((state) => state.auth.profileData);
  const isSubscriptionRestricted = useSelector(selectIsSubscriptionRestricted);
  const location = useLocation();

  if (!user) {
    return <Navigate to={LOGIN_PATH} replace state={{ from: location }} />;
  }

  const currentPath = location.pathname || "/";
  const profileData = user?.profileData || authProfileData;
  const userForPerms =
    profileData && user.profileData !== profileData
      ? { ...user, profileData }
      : user;

  if (isSubscriptionRestricted && !isBillingAllowedPath(currentPath)) {
    return <Navigate to={BILLING_PATH} replace />;
  }

  // Stripe return: confirm payment without requiring Settings section access
  if (currentPath.toLowerCase().startsWith("/payment/stripe-return")) {
    return <Outlet />;
  }

  const section = resolveSectionByPath(currentPath);

  if (isPathBlockedForCompany(profileData, currentPath)) {
    return <Navigate to={getDefaultAuthorizedPath(userForPerms)} replace />;
  }

  if (section && !hasSectionAccess(userForPerms, section)) {
    return <Navigate to={getDefaultAuthorizedPath(userForPerms)} replace />;
  }

  if (currentPath.toLowerCase().startsWith("/report") && !hasReportRouteAccess(userForPerms, currentPath)) {
    return <Navigate to={getDefaultAuthorizedPath(userForPerms)} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;